module.exports = __webpack_public_path__ + "static/media/Minneriya.f6dd7e00.png";